import * as z from "zod/v4";

export const InventoryViewType = z.enum([
  "purchase-orders",
  "shipments",
  "transfers",
  "inventory-levels",
  "forecasting",
  "catalog-products",
]);
export type InventoryViewType = z.infer<typeof InventoryViewType>;
